module.exports = __webpack_public_path__ + "53676e4a5de07fd214e1d304f90b53ca.pdf";